<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close">
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">
    Add Staff Users
  </h4>
</div>
<div class="modal-body">
  <div class="row" style="margin-top: 30px;" *ngIf="availableUsers?.length > 0; else noAvailableUsers">
    <div class="col-md-4" *ngFor="let u of availableUsers" (click)="toggleUserSelection(u)">
      <div class="user-invite" [ngClass]="{'selected': u.selected}">
        <div class="user-avatar">
          <div class="avatar avatar-48">
            <img *ngIf="u?.user?.pictureUrl; else noPicturePlaceholder" src="{{ u?.user?.pictureUrl }}">
            <ng-template #noPicturePlaceholder>
              <div class="avatar-inicitials" initials [name]="u?.user?.full_name"></div>
            </ng-template>
          </div>
        </div>
        <div class="user-info">
          <div class="name">{{u?.user?.full_name}}</div>
          <div class="email">{{u?.user?.email}}</div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noAvailableUsers>
    <div style="margin: 25px 0 25px 10px; font-weight: 700;">
      <div *ngIf="showNoAvailableUsersMessage">It seems all staff users are already assigned to this workspace :(</div>
    </div>
  </ng-template>
</div>

<div class="modal-footer">
  <div class="row">
    <div class="col-4 text-left">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
    <div class="col-8">
      <button type="button" [disabled]="selectedUsers.length == 0"
      class="btn btn-primary"
      (click)="assignUsers()">
        <span>Assign Users</span>
      </button>
    </div>
  </div>
</div>